import { type TBlock } from '@wp-block-builder/package';

export type TBlockButton<TBlockProp extends TBlock = TBlock> = {
  label: string;
  icon: JSX.Element;
  defaultBlock: () => TBlockProp;
  defaultContainerBlock: () => TBlockProp;
  defaultColumnBlock: () => TBlockProp;
};

export default function defineBlockButton<TBlockProp extends TBlock>(
  props: TBlockButton<TBlockProp>
): TBlockButton<TBlockProp> {
  return props;
}
